// pages/StockVisualization.js
import React, { useEffect, useContext } from 'react';
import { STOCKS } from '../constants/stocks';
import StockVisualizationCharts from '../components/StockVisualizationCharts';
import DateFilterButtons from '../components/DateFilterButtons';
import { WatchlistContext } from '../contexts/StockWatchlistContext';
import { StockVisualizationContext } from '../contexts/StockVisualizationContext';
import { fetchHistoricalData } from '../api';
import './StockVisualization.css';
import '../styles.css';

export default function StockVisualization() {
  const stockMap = STOCKS.reduce((acc, { symbol, name }) => {
    acc[symbol] = name;
    return acc;
  }, {});

  const {
    selectedStock,
    selectedPeriod,
    handleWatchlistStockChange,
    handlePeriodChange,
    chartData,
    setChartData,
    isChartDataLoaded,
    setIsChartDataLoaded
  } = useContext(StockVisualizationContext);

  const { symbols: watchlistStocks } = useContext(WatchlistContext);

  useEffect(() => {
    setIsChartDataLoaded(false);
  }, [selectedStock, setIsChartDataLoaded]);

  useEffect(() => {
    if (isChartDataLoaded) return;

    const fetchStockData = async () => {
      try {
        const data = await fetchHistoricalData(selectedStock);
        if (data && data.length) {
          const formattedData = data.reverse().map(day => ({
            date: day.date,
            open: day.open,
            high: day.high,
            low: day.low,
            close: day.close,
            volume: day.volume,
            vwap: day.vwap,
            isUp: day.close >= day.open,
            bodyRange: Math.abs(day.close - day.open),
            changePercent: day.changePercent
          }));
          setChartData(formattedData);
          setIsChartDataLoaded(true);
        } else {
          setChartData([]);
        }
      } catch (error) {
        console.error("Error fetching chart data:", error);
        setChartData([]);
      }
    };

    fetchStockData();
  }, [selectedStock, isChartDataLoaded, setChartData, setIsChartDataLoaded]);

  return (
    <div className="App">
      <div className="main-container">
        <div className="content-area">
          <div className="visualization-selector-container">
            <h2>Stock Visualization</h2>
            <div className="stock-selector-container">
              <select
                className="watchlist-select"
                value=""
                onChange={handleWatchlistStockChange}
              >
                <option value="">From Watchlist</option>
                {watchlistStocks.map((ticker) => (
                  <option key={ticker} value={ticker}>
                    {stockMap[ticker] || ticker} ({ticker})
                  </option>
                ))}
              </select>
              <DateFilterButtons
                selectedPeriod={selectedPeriod}
                onPeriodChange={handlePeriodChange}
              />
            </div>
          </div>

          <div className="metrics-container">
            <div className="charts-container">
              <StockVisualizationCharts
                chartData={chartData}
                selectedPeriod={selectedPeriod}
                stockInfo={{
                  name: stockMap[selectedStock],
                  ticker: selectedStock
                }}
              />
            </div>
          </div>
        </div>
      </div>

    </div>
    
  );
}
